import * as yup from 'yup';

export const aiSettingsSchema = yup.object({
  personality: yup
    .string()
    .required('Personality is required')
    .oneOf(
      [
        'Friendly & Casual',
        'Professional & Formal',
        'Enthusiastic & Energetic',
        'Calm & Supportive',
      ],
      'Invalid personality type'
    ),
  enableAutoFollowUp: yup.boolean().required(),
  enableAutoSuggestion: yup.boolean().required(),
  coldLeadDelayTime: yup
    .string()
    .required('Time delay is required')
    .oneOf(['24h', '48h', '72h', '168h'], 'Invalid time delay'),
  scoreCustomization: yup
    .string()
    .required('Lead scoring is required')
    .oneOf(
      [
        'Cold Lead = Seen but no reply',
        "Warm Lead = Opens product but doesn't message",
        'Hot Lead = Response within 10 min & asks price',
      ],
      'Invalid lead scoring type'
    ),
  followUpMessage: yup
    .string()
    .required('Follow-up message is required')
    .min(10, 'Follow-up message must be at least 10 characters')
    .max(500, 'Follow-up message must not exceed 500 characters'),
});

export type AiSettingsFormData = yup.InferType<typeof aiSettingsSchema>;
